import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { IfcEmbedderProps } from "./ifc-embedder/IfcEmbedder.types";
import IfcEmbedder from "./ifc-embedder/ifc-embedder";
import { application } from "../../_runtime/bootstrap";
import { useEffect, useState } from "react";
import { Initials, Loader, STATUS_TYPE, StatusTag } from "taltech-styleguide";
import { ActionButton } from "../../components-common/buttons/ActionButton";

/**
 * Viewer Component
 *
 * Renders an IFC viewer for an assignment submission.
 *
 * @param {Object} props - Component properties.
 * @param {Object} props.assignmentSubmission - The assignment submission data.
 * @returns {JSX.Element} - The rendered IFC viewer.
 */
const Viewer = ({ assignmentSubmission }: any) => {
  const { modelUrl: fileUrl, user } = assignmentSubmission;
  const ifcProps: IfcEmbedderProps = {
    iFrameUrl:
      "https://taltech-edubim-eun-prod-webdistellar-app.azurewebsites.net",
    iFrameKey: "BL+DY8Ad4=*sHO)I",
    iFrameTokenMinSecondsDifference: 1800,
    fileUrl: fileUrl as string,
    style: { width: "100%", height: "100%", borderRadius: "5px" },
  };

  return (
    <div className="position-relative h-100">
      <div className="d-flex justify-content-between align-items-center">
        <h1>IFC Viewer</h1>
        <ActionButton kind="back" />
      </div>
      <div className="mb-3">
        <IfcEmbedder {...ifcProps} fileUrl={fileUrl as string} />
      </div>
      <div
        className="position-absolute d-flex align-items-center gap-3"
        style={{
          bottom: "0px",
          left: "calc(50% - 200px)",
        }}
      >
        <div className="h-100 bg-white shadow py-1 px-2 rounded">
          {user.role}
        </div>
        <div className="d-flex justify-content-between gap-2 bg-white shadow py-1 px-2 rounded">
          <div className="d-flex gap-2">
            <Initials
              imageUrl={user.imgUrl}
              name={user.displayName}
              size="xs"
            />
            <span>{user.displayName}</span>
          </div>
          <span>{user.email}</span>
        </div>
      </div>
    </div>
  );
};

/**
 * DiStellarViewer Component
 *
 * Fetches and displays an assignment submission using the Viewer component.
 *
 * @returns {JSX.Element} - The rendered DiStellar viewer.
 */
export const DiStellarViewer = () => {
  const [loading, setLoading] = useState(true);
  const [currentSubmission, setCurrentSubmission] = useState<any>(undefined);
  const { submissionId } = useParams();

  useEffect(() => {
    if (submissionId !== undefined) {
      application
        .getHttpClient()
        .get(`/coursesms/assignments/submissions/${submissionId}`)
        .then((response: any) => {
          setCurrentSubmission(response.body);
        });
    } else {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (currentSubmission) {
      setLoading(false);
    }
  }, [currentSubmission]);

  return (
    <>
      {loading && <Loader fullScreen />}
      {!loading && <Viewer assignmentSubmission={currentSubmission} />}
    </>
  );
};
